import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27508c9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { ref, reactive } from "vue";
import { ElCarouselItem, ElCarousel } from "element-plus";
import "element-plus/theme-chalk/el-carousel.css";
import "element-plus/theme-chalk/el-carousel-item.css";
import "element-plus/theme-chalk/base.css";
import { useRoute, useRouter } from "vue-router";
import Bus from "../utils/bus";

export default /*#__PURE__*/_defineComponent({
  __name: 'simpleSwiper',
  setup(__props) {

const route = useRoute();
const router = useRouter();
// 引入bus
let articleList = ref([]);
// 接收事件
Bus.on("hasInit", list => {
  console.log("接收的值为", list);
  articleList.value = list.map(val => {
    return { ...val };
  });
});
// 前往文章详情

let articleDetail = item => {
  console.log(item.column.parent_id, "item.column");
  router.push({
    path: "/pages/detail/detail",
    query: {
      id: item.id,
      level1Id: item.column.parent_id,
      level2Id: item.column_id
    }
  });
};
let swiperChange=(e)=>{
// 通过Bus发布出去一个'on-click'事件，并携带flag 参数
  Bus.emit("change", e);
  console.log("接收的值为ee", e);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ElCarousel), {
      class: "swiper-wrap",
      "indicator-position": "outside",
      autoplay: false,
      onChange: _unref(swiperChange),
      arrow: "never"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleList), (item, index) => {
          return (_openBlock(), _createBlock(_unref(ElCarouselItem), {
            class: "swiper-item",
            onClick: ($event: any) => (_unref(articleDetail)(item)),
            key: item
          }, {
            default: _withCtx(() => [
              (!item.video_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "img",
                    src: item.image_url,
                    alt: ""
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
              (item.video_url)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 1,
                    autoplay: "",
                    loop: false,
                    muted: "",
                    controls: "",
                    class: "img",
                    src: item.video_url
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onChange"])
  ]))
}
}

})